import { ITangNha } from "../../../model/respone/category/ITangNha";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTangNhaActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ITangNha[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as ITangNha | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as ITangNha,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eTangNhaActionIds = generateActionTypeIds(
  eTangNhaActionsObj,
  "TANG_NHA"
);

export type ITangNhaActionTypes = IGenericActionType<
  typeof eTangNhaActionsObj,
  "TANG_NHA"
>;